/* Sturdy welcome offer popup.
   One step: email, mobile optional. The middleware mints the code and writes
   the contact to Maropost; the welcome email delivers the code. Nothing that
   matters is decided here, and the code is never on screen. */
(function () {
  "use strict";

  var STORE_KEY = "sturdy_gift_popup";

  var root = document.getElementById("sturdy-subscribe-popup");
  if (!root) { return; }

  var config = {
    api: (root.dataset.apiBase || "").replace(/\/+$/, ""),
    minSeconds: parseInt(root.dataset.minSeconds, 10) || 0,
    scrollPercent: parseInt(root.dataset.scrollPercent, 10) || 0,
    exitIntent: root.dataset.exitIntent === "true",
    dismissDays: parseInt(root.dataset.dismissDays, 10) || 7,
    countryCode: root.dataset.countryCode || "61",
    testMode: root.dataset.testMode === "true"
  };

  /* Where the visitor is. The section liquid sets these, so the script never
     has to guess a product from the URL. */
  var page = {
    type: root.dataset.pageType || "",
    handle: root.dataset.pageHandle || "",
    product: root.dataset.productHandle ? {
      kind: "product",
      handle: root.dataset.productHandle,
      title: root.dataset.productTitle || "",
      url: root.dataset.productUrl || window.location.href.split("?")[0],
      image: root.dataset.productImage || "",
      price: root.dataset.productPrice || "",
      vendor: root.dataset.productVendor || "",
      type: root.dataset.productType || ""
    } : null,
    collection: root.dataset.pageType === "collection" && root.dataset.pageHandle ? {
      kind: "collection",
      handle: root.dataset.pageHandle,
      title: root.dataset.pageTitle || "",
      url: window.location.href.split("?")[0]
    } : null
  };

  /* "product/babolat-pure-drive-98", "collection/tennis-bags", "index". */
  function pageRef() {
    var ref = page.type || "page";
    if (page.handle) { ref += "/" + page.handle; }
    return ref.slice(0, 120);
  }

  /* ---------------------------------------------------------------- state */

  function readState() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY)) || {}; }
    catch (error) { return {}; }
  }

  function writeState(patch) {
    var next = Object.assign(readState(), patch);
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(next)); } catch (error) { /* private mode */ }
    return next;
  }

  /* ------------------------------------------------------------- browsing */

  /* The products and collections this browser has looked at, newest first,
     kept on the device. It leaves the device only with a subscription (so the
     welcome email can speak to what they were looking at) and, once
     subscribed, as each further product or collection is viewed. */
  var BROWSE_KEY = "sturdy_browse";
  var BROWSE_LIMIT = 20;

  function readTrail() {
    try {
      var trail = JSON.parse(window.localStorage.getItem(BROWSE_KEY));
      return Array.isArray(trail) ? trail : [];
    } catch (error) { return []; }
  }

  function rememberView(item) {
    var trail = readTrail().filter(function (row) {
      return !(row.kind === item.kind && row.handle === item.handle);
    });
    trail.unshift(Object.assign({}, item, { at: Date.now() }));
    try { window.localStorage.setItem(BROWSE_KEY, JSON.stringify(trail.slice(0, BROWSE_LIMIT))); } catch (error) { /* private mode */ }
  }

  /* After subscribing, each view is reported against the subscription so the
     next email can be about what they actually looked at. */
  function reportView(item) {
    var subscriptionId = readState().subscriptionId;
    if (!config.api || !subscriptionId) { return; }
    try {
      window.fetch(config.api + "/api/v1/browse", {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subscription_id: subscriptionId, view: item })
      }).catch(function () { /* never surfaced */ });
    } catch (error) { /* never surfaced */ }
  }

  var currentView = page.product || page.collection;
  if (currentView) {
    rememberView(currentView);
    reportView(currentView);
  }

  /* Suppressed when: already subscribed, dismissed inside the cool-off window,
     or the visitor asked for no popup with ?nopopup=1. Test mode ignores all
     three so the theme editor can keep reopening it. */
  function suppressed() {
    if (config.testMode) { return false; }
    if (window.location.search.indexOf("nopopup=1") > -1) { return true; }
    var state = readState();
    if (state.subscribed) { return true; }
    if (state.dismissedUntil && Date.now() < state.dismissedUntil) { return true; }
    return false;
  }

  /* ------------------------------------------------------------- elements */

  var dialog = root.querySelector(".sr-popup__dialog");
  var panes = {
    1: root.querySelector('[data-pane="1"]'),
    2: root.querySelector('[data-pane="2"]')
  };
  var detailsForm = root.querySelector('[data-role="details-form"]');
  var successBody = root.querySelector('[data-role="success-body"]');
  var successSms = root.querySelector('[data-role="success-sms"]');
  var launcher = document.getElementById("sturdy-gift-launcher");

  var session = { opened: false, lastFocus: null };

  /* ---------------------------------------------------------------- utils */

  function message(pane, text, tone) {
    var node = panes[pane].querySelector('[data-role="message"]');
    if (!node) { return; }
    node.textContent = text || "";
    node.setAttribute("data-tone", tone || "error");
  }

  function busy(button, active, label) {
    if (!button.dataset.label) { button.dataset.label = button.textContent; }
    button.disabled = active;
    if (active) {
      button.innerHTML = "";
      var spinner = document.createElement("span");
      spinner.className = "sr-button__spinner";
      button.appendChild(spinner);
      button.appendChild(document.createTextNode(" " + (label || "Working...")));
    } else {
      button.textContent = button.dataset.label;
    }
  }

  function markField(name, invalid) {
    var field = root.querySelector('[data-field="' + name + '"]');
    if (field) { field.setAttribute("data-invalid", invalid ? "true" : "false"); }
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
  }

  function digits(value) {
    return String(value || "").replace(/[^\d+]/g, "");
  }

  /* ------------------------------------------------------------ telemetry */

  /* An opaque per-browser id so the funnel counts people rather than clicks.
     It identifies nobody: random, local to this device, and never joined to a
     signup record. Everything here is wrapped so that telemetry can never be
     the reason a visitor cannot claim their offer. */
  var VISIT_KEY = "sturdy_gift_visit";

  function visitId() {
    try {
      var id = window.localStorage.getItem(VISIT_KEY);
      if (!id) {
        id = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        window.localStorage.setItem(VISIT_KEY, id);
      }
      return id;
    } catch (error) { return null; }
  }

  function track(event, step) {
    if (!config.api) { return; }
    var id = visitId();
    if (!id) { return; }
    try {
      window.fetch(config.api + "/api/v1/event", {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visit_id: id,
          event: event,
          step: step || null,
          page: pageRef(),
          device: window.matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop"
        })
      }).catch(function () { /* never surfaced */ });
    } catch (error) { /* never surfaced */ }
  }

  function currentStep() {
    return Number(root.getAttribute("data-step")) || 1;
  }

  async function api(path, payload) {
    if (!config.api) {
      throw new Error("The subscription service is not configured yet.");
    }
    var response = await fetch(config.api + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    var data = {};
    try { data = await response.json(); } catch (error) { /* no body */ }
    if (!response.ok) {
      var failure = new Error(data.message || "Something went wrong. Please try again.");
      failure.status = response.status;
      failure.reason = data.reason || "";
      throw failure;
    }
    return data;
  }

  /* ------------------------------------------------------------ open/close */

  function focusable() {
    return Array.prototype.slice
      .call(dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (node) { return !node.disabled && node.offsetParent !== null; });
  }

  function trapFocus(event) {
    if (event.key === "Escape") { close("escape"); return; }
    if (event.key !== "Tab") { return; }
    var items = focusable();
    if (!items.length) { return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* The launcher is the way back in after a close, so it ignores the dismissal
     window — but never appears once someone has subscribed. */
  function updateLauncher() {
    if (!launcher) { return; }
    var done = readState().subscribed;
    launcher.hidden = session.opened || done;
  }

  if (launcher) {
    launcher.addEventListener("click", function () {
      open();
      updateLauncher();
    });
  }

  function open() {
    if (session.opened) { return; }
    session.opened = true;
    session.lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute("data-open", "true");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", trapFocus);
    updateLauncher();
    track("shown", currentStep());
    window.setTimeout(function () {
      var target = panes[2].getAttribute("data-active") === "true"
        ? root.querySelector('[data-pane="2"] [data-action="close"]')
        : detailsForm.elements.email;
      if (target) { target.focus(); }
    }, 260);
  }

  /* A close before subscribing is a dismissal; after it, the visitor is done
     and should never be asked again. */
  function close(reason) {
    var subscribed = reason === "subscribed" || panes[2].getAttribute("data-active") === "true";
    root.setAttribute("data-open", "false");
    root.hidden = true;
    session.opened = false;
    document.body.style.overflow = "";
    document.removeEventListener("keydown", trapFocus);
    if (session.lastFocus && session.lastFocus.focus) { session.lastFocus.focus(); }

    if (!subscribed) {
      track("dismissed", currentStep());
      writeState({ dismissedUntil: Date.now() + config.dismissDays * 86400000 });
    }
    updateLauncher();
  }

  function goTo(step) {
    root.setAttribute("data-step", String(step));
    Object.keys(panes).forEach(function (key) {
      panes[key].setAttribute("data-active", String(Number(key) === step));
    });
  }

  /* --------------------------------------------------------------- the form */

  /* The dropdown is the source of truth; the section setting is only the
     starting selection, and a theme without the select falls back to it. */
  function countryCode() {
    var select = detailsForm.elements.country_code;
    var value = select ? select.value : config.countryCode;
    return String(value || config.countryCode).replace(/\D/g, "");
  }

  function collectDetails() {
    return {
      email: detailsForm.elements.email.value.trim(),
      phone: digits(detailsForm.elements.phone ? detailsForm.elements.phone.value : ""),
      country_code: countryCode(),
      /* The fine print under the button is the consent statement; sending the
         form is the act of agreeing to it. */
      consent: true,
      page: pageRef(),
      /* What they looked at before signing up, newest first. */
      browsed: readTrail()
    };
  }

  function validateDetails(payload) {
    var problems = [];

    markField("email", !validEmail(payload.email));
    if (!validEmail(payload.email)) { problems.push("email"); }

    /* Mobile is optional: blank is fine, anything typed has to look like one. */
    var national = payload.phone.replace(/\D/g, "").replace(/^0+/, "");
    var phoneOk = !payload.phone || (national.length >= 6 && national.length <= 14);
    markField("phone", !phoneOk);
    if (!phoneOk) { problems.push("phone"); }

    return problems;
  }

  function showSuccess(result) {
    if (successBody) {
      var template = successBody.getAttribute("data-template") || successBody.textContent;
      successBody.textContent = template.replace("{email}", result.masked_email || "your inbox");
    }
    if (successSms) { successSms.hidden = !result.sms; }
    goTo(2);
    track("subscribed", 2);
    writeState({
      subscribed: true,
      subscribedAt: Date.now(),
      dismissedUntil: 0,
      /* Kept so later product views can be reported against this signup. */
      subscriptionId: result.subscription_id || null
    });
    window.setTimeout(function () {
      var cta = root.querySelector('[data-pane="2"] [data-action="close"]');
      if (cta) { cta.focus(); }
    }, 220);
  }

  detailsForm.addEventListener("submit", async function (event) {
    event.preventDefault();
    var button = detailsForm.querySelector('[data-role="submit-details"]');
    var payload = collectDetails();
    var problems = validateDetails(payload);

    if (problems.length) {
      message(1, "Please check the highlighted field.");
      var firstBad = root.querySelector('[data-field="' + problems[0] + '"] input');
      if (firstBad) { firstBad.focus(); }
      return;
    }

    message(1, "");
    busy(button, true, "Sending...");
    track("submitted", 1);
    try {
      var result = await api("/api/v1/subscribe", payload);
      showSuccess(result);
    } catch (error) {
      /* Every failure reads in the danger colour, including "already subscribed" — a grey line was too easy to miss. */
      var tone = "error";
      message(1, error.message, tone);
      if (error.reason === "phone_registered") { markField("phone", true); }
    }
    busy(button, false);
  });

  detailsForm.addEventListener("input", function (event) {
    var field = event.target.closest("[data-field]");
    if (field) { field.setAttribute("data-invalid", "false"); }
    track("started", 1);
  });

  /* -------------------------------------------------------------- actions */

  root.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-action]");
    if (!trigger) { return; }
    if (trigger.dataset.action === "close") {
      close(panes[2].getAttribute("data-active") === "true" ? "subscribed" : "closed");
    }
  });

  /* No click-outside-to-close: the only ways out are the X and Escape, so a
     half-filled form is never lost to a stray click. Escape stays because a
     modal dialog must be dismissible from the keyboard. */

  /* -------------------------------------------------------------- trigger */

  function scrolledPercent() {
    var height = document.documentElement.scrollHeight - window.innerHeight;
    if (height <= 0) { return 100; }
    return (window.scrollY / height) * 100;
  }

  function watch() {
    /* The launcher shows even when the popup itself is suppressed: that is the
       whole point of it — a way back after an accidental close. */
    updateLauncher();
    if (suppressed()) { return; }

    /* Any one of these opens it: the timer, a scroll depth (only if one is
       set), or the cursor leaving the page on desktop. Whichever comes first. */
    var readyAt = Date.now() + config.minSeconds * 1000;
    var exitReadyAt = Date.now() + Math.min(config.minSeconds, 4) * 1000;
    var armed = true;

    function disarm() {
      armed = false;
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onMouseOut);
    }

    function fire() {
      if (!armed || session.opened) { return; }
      disarm();
      open();
    }

    function onScroll() {
      if (Date.now() < readyAt) { return; }
      if (scrolledPercent() >= config.scrollPercent) { fire(); }
    }

    /* Exit intent: the cursor leaves through the top of the window. Touch
       devices never produce this, which is what keeps it desktop-only. */
    function onMouseOut(event) {
      if (event.relatedTarget || event.clientY > 0) { return; }
      if (Date.now() < exitReadyAt) { return; }
      fire();
    }

    if (config.scrollPercent > 0) { window.addEventListener("scroll", onScroll, { passive: true }); }
    if (config.exitIntent) { document.addEventListener("mouseout", onMouseOut); }
    window.setTimeout(fire, Math.max(config.minSeconds, 1) * 1000 + 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }

  /* Exposed for QA: sturdyGiftPopup.open() / .reset() from the console. */
  window.sturdyGiftPopup = {
    open: open,
    close: close,
    reset: function () {
      try { window.localStorage.removeItem(STORE_KEY); } catch (error) { /* noop */ }
      goTo(1);
      message(1, "");
    }
  };
})();
